import { render } from "./PlanetChart.vue?vue&type=template&id=25af6939"
import script from "./PlanetChart.vue?vue&type=script&lang=js"
export * from "./PlanetChart.vue?vue&type=script&lang=js"
script.render = render

export default script